<template>
  <div v-if="debugMode">
    <p v-if="connected" class="text-green-500">CONNECTED</p>
    <p v-else class="text-red-500">NOT CONNECTED</p>

    <p>Logged-in: {{ !props.isGuest }}</p>

    <p>
      OS: <span v-if="results.os.value == null">Loading...</span>
      <span v-if="results.os.value == true" class="text-green-500">
        OK ({{ data.osDetails.value }})
      </span>
      <span v-if="results.os.value == false" class="text-red-500">
        NOK ({{ data.osDetails.value }})
      </span>
    </p>

    <p>
      Mobile:
      <span v-if="browser.isMobile()" class="text-green-500"> OK </span>
      <span v-if="!browser.isMobile()" class="text-red-500"> NOK </span>
    </p>

    <p>
      Browser:
      <span v-if="results.browser.value == null">Loading...</span>
      <span v-if="results.browser.value == true" class="text-green-500">
        OK ({{ data.browser.value }})
      </span>
      <span v-if="results.browser.value == false" class="text-red-500">
        NOK ({{ data.browser.value }})
      </span>
    </p>

    <p v-if="results.browser.value == true">
      Browser version:
      <span v-if="results.browserVersion.value == null">Loading...</span>
      <span v-if="results.browserVersion.value == true" class="text-green-500">
        OK ({{ data.browserVersion.value }})
      </span>
      <span v-if="results.browserVersion.value == false" class="text-red-500">
        NOK ({{ data.browserVersion.value }})
      </span>
      <span
        v-if="results.browserVersion.value == false"
        class="ms-2 text-sm text-wt-gray-d italic"
      >
        Mettez à jour votre navigateur vers la dernière version
      </span>
    </p>

    <p v-if="results.browser.value == true">
      Bandwidth: <span v-if="kbps == null">Loading...</span>
      <span
        v-else
        :class="{
          'text-red-500': kbps < 106,
          'text-green-500': kbps >= 106,
        }"
      >
        {{ (kbps * 8).toFixed(2) }} kbps
      </span>
    </p>

    <p v-if="results.browser.value == true">
      Drops:
      <span>
        {{ unstableConnectionCount }}
      </span>
    </p>

    <p v-if="results.browser.value == true">
      Average Bandwidth:
      <span> {{ ((totalKbps / totalKbpsCount) * 8).toFixed(2) }} kbps </span>
    </p>

    <p v-if="isFinished">FINISHED!</p>
  </div>

  <div class="text-center">
    <p class="text-2xl font-bold">{{ $t('compatibilityTest.title') }}</p>
    <div v-if="!isFinished && !isStarted">
      <svg
        class="mx-auto mt-16 mb-8 w-52"
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 738.21997 557.74675"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <path
          id="a9afa624-d143-4da3-9790-afb66062e65a-510"
          data-name="Path 2429"
          d="M535.17415,599.59713c0,19.24928-14.948,34.85393-33.38792,34.85393s-33.38792-15.60461-33.38792-34.85393c0-.43634.00676-.86964.0246-1.3023.33849-19.24559,15.56341-34.5554,33.99969-34.196s33.10172,16.2527,32.75707,35.49829Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#31319d"
        />
        <path
          id="e3bc7ff1-d70c-4de9-8a31-9e1cd8f5d93e-511"
          data-name="Path 2431"
          d="M490.02877,615.07623l-9.61633-12.8222,2.27715-1.7091,7.83463,10.44595,30.84427-25.23327,1.80325,2.20391Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#fff"
        />
        <rect
          id="a7b62467-cb6d-4a33-bede-3daf66fae9b8"
          data-name="Rectangle 256"
          y="555.74672"
          width="738.21997"
          height="2"
          fill="#e6e6e6"
        />
        <g id="a0df80b4-37f6-4e81-b192-ad058c9b46d3" data-name="Group 24">
          <path
            id="ab0ed44f-d533-4992-a1b3-ca9ac72248ac-512"
            data-name="Path 552"
            d="M716.948,409.11358a14.21117,14.21117,0,0,1,1.987,1.108l63.154-26.954,2.253-16.636,25.235-.155-1.491,38.158-83.357,22.047a14.94008,14.94008,0,0,1-.631,1.7,14.411,14.411,0,1,1-7.151-19.265Z"
            transform="translate(-230.89001 -213.15682)"
            fill="#a0616a"
          />
          <path
            id="e96706e1-851e-4da2-ad9b-ad313a8c64fc-513"
            data-name="Path 553"
            d="M818.754,754.87454H801.491l-8.212-66.584h25.477Z"
            transform="translate(-230.89001 -213.15682)"
            fill="#a0616a"
          />
          <path
            id="b540b71d-0f03-4ed3-b276-b3415efc1443-514"
            data-name="Path 554"
            d="M789.161,749.94255h33.292v20.955H768.199a20.962,20.962,0,0,1,20.962-20.962h0Z"
            transform="translate(-230.89001 -213.15682)"
            fill="#2f2e41"
          />
          <path
            id="b87c34d6-a0a3-40d8-a436-08cd71fc342e-515"
            data-name="Path 555"
            d="M885.89,749.99658l-17.178,1.69-14.7-65.458,25.355-2.491Z"
            transform="translate(-230.89001 -213.15682)"
            fill="#a0616a"
          />
          <path
            id="bb56473f-8578-4371-8d17-16b3f8ffc95c-516"
            data-name="Path 556"
            d="M855.946,747.99257l33.126-3.263,2.054,20.857-53.981,5.317a20.958,20.958,0,0,1,18.8-22.911Z"
            transform="translate(-230.89001 -213.15682)"
            fill="#2f2e41"
          />
          <circle
            id="b06ede21-2df7-4399-95f3-667c473f6547"
            data-name="Ellipse 84"
            cx="592.669"
            cy="48.26774"
            r="34.583"
            fill="#a0616a"
          />
          <path
            id="e3edd339-fa60-4375-a5a7-b8711a5f77a0-517"
            data-name="Path 557"
            d="M797.633,741.40854a6.3,6.3,0,0,1-6.217-5.21c-8.929-49.59-38.141-211.772-38.84-216.268a1.99063,1.99063,0,0,1-.023-.312V507.52456a2.1,2.1,0,0,1,.393-1.228l3.858-5.4a2.082,2.082,0,0,1,1.611-.88c22-1.031,94.036-4.054,97.516.294h0c3.495,4.365,2.253,17.611,1.971,20.22l.014.272,32.366,206.98211a6.353,6.353,0,0,1-5.233,7.23l-20.214,3.33a6.366,6.366,0,0,1-7.076-4.355c-6.252-19.978-27.216-87.184-34.482-113.19a.7.7,0,0,0-1.381.2c.363,24.79,1.24,88.036,1.549,109.881l.032,2.353a6.362,6.362,0,0,1-5.763,6.387l-19.492,1.766A5.8754,5.8754,0,0,1,797.633,741.40854Z"
            transform="translate(-230.89001 -213.15682)"
            fill="#2f2e41"
          />
          <path
            id="fafafea0-d187-42ce-9adc-60692d5c21c2-518"
            data-name="Path 99"
            d="M801.611,309.60656c-6.035,3.588-9.647,10.18-11.719,16.9a160.07254,160.07254,0,0,0-6.877,38.241l-2.191,38.86-27.113,103.028c23.5,19.883,37.053,15.363,68.686-.9s35.246,5.422,35.246,5.422l6.325-87.663,9.037-95.793a42.48654,42.48654,0,0,0-6.846-6.581,69.923,69.923,0,0,0-59.761-12.673Z"
            transform="translate(-230.89001 -213.15682)"
            fill="#31319d"
          />
          <path
            id="bcb42d09-5dc7-4cce-9178-bbabc9608de0-519"
            data-name="Path 558"
            d="M792.805,429.92056a14.82766,14.82766,0,0,1,2.112.986l62.447-31.259,1.036-16.933,25.759-1.776,1.38,38.6-83.45,27.6a14.784,14.784,0,1,1-9.283-17.223Z"
            transform="translate(-230.89001 -213.15682)"
            fill="#a0616a"
          />
          <path
            id="a6b68414-708f-47b2-ba8b-69f9e74523ce-520"
            data-name="Path 101"
            d="M872.555,328.13256c15.363,5.422,18.071,64.171,18.071,64.171-18.075-9.941-39.765,6.326-39.765,6.326s-4.518-15.365-9.941-35.246a34.54,34.54,0,0,1,7.229-32.535S857.19,322.70758,872.555,328.13256Z"
            transform="translate(-230.89001 -213.15682)"
            fill="#31319d"
          />
          <path
            id="bcacc9ce-a4f2-4033-9198-64d9603f2d9b-521"
            data-name="Path 102"
            d="M854.562,270.56756c-4.309-3.447-10.187,2.816-10.187,2.816l-3.447-31.016s-21.543,2.581-35.334-.862-15.943,12.5-15.943,12.5a110.65357,110.65357,0,0,1-.431-19.391c.862-7.756,12.064-15.512,31.885-20.683s30.162,17.236,30.162,17.236C865.063,238.05658,858.876,274.01858,854.562,270.56756Z"
            transform="translate(-230.89001 -213.15682)"
            fill="#2f2e41"
          />
        </g>
        <path
          d="M392.01957,258.70856a3.10716,3.10716,0,0,0,0,6.21431H618.87829a3.10716,3.10716,0,0,0,0-6.21431Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#ccc"
        />
        <path
          d="M392.01957,277.35146a3.10717,3.10717,0,0,0-.01311,6.21432H535.42889a3.10716,3.10716,0,1,0,0-6.21432Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#ccc"
        />
        <path
          id="baa6ea24-e79a-410b-95a0-90b7a92ae1c1-522"
          data-name="Path 2429"
          d="M616.03488,234.95609c0,7.53426-5.8507,13.642-13.06819,13.642s-13.0682-6.10772-13.0682-13.642c0-.17079.00265-.34038.00963-.50973.13249-7.53282,6.09159-13.52515,13.30764-13.38447s12.95618,6.36138,12.82128,13.8942Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#31319d"
        />
        <path
          id="a0820f47-ad40-463a-872c-13bb80005143-523"
          data-name="Path 2431"
          d="M598.36476,241.01468l-3.76388-5.01867.89129-.669,3.06651,4.0886,12.0726-9.87642.7058.86262Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#fff"
        />
        <path
          d="M392.01957,372.70856a3.10716,3.10716,0,0,0,0,6.21431H618.87829a3.10716,3.10716,0,0,0,0-6.21431Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#ccc"
        />
        <path
          d="M392.01957,391.35146a3.10717,3.10717,0,0,0-.01311,6.21432H535.42889a3.10716,3.10716,0,1,0,0-6.21432Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#ccc"
        />
        <path
          id="b63fc892-67cf-40d0-9003-f173040a559c-524"
          data-name="Path 2429"
          d="M615.03488,348.95609c0,7.53426-5.8507,13.642-13.06819,13.642s-13.0682-6.10772-13.0682-13.642c0-.17079.00265-.34038.00963-.50973.13249-7.53282,6.09159-13.52515,13.30764-13.38447s12.95618,6.36138,12.82128,13.8942Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#31319d"
        />
        <path
          id="b8e61bbe-38fc-40ac-ac8c-5bb63bac7af2-525"
          data-name="Path 2431"
          d="M597.36476,355.01468l-3.76388-5.01867.89129-.66895,3.06651,4.0886,12.0726-9.87642.7058.86262Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#fff"
        />
        <path
          d="M392.01957,486.70856a3.10716,3.10716,0,0,0,0,6.21431H618.87829a3.10716,3.10716,0,0,0,0-6.21431Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#ccc"
        />
        <path
          d="M392.01957,505.35146a3.10717,3.10717,0,0,0-.01311,6.21432H535.42889a3.10716,3.10716,0,1,0,0-6.21432Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#ccc"
        />
        <path
          id="f67391c6-f0f4-4d09-a78c-675b0edf0c3b-526"
          data-name="Path 2429"
          d="M615.03488,462.95609c0,7.53426-5.8507,13.642-13.06819,13.642s-13.0682-6.10772-13.0682-13.642c0-.17079.00265-.34038.00963-.50973.13249-7.53282,6.09159-13.52515,13.30764-13.38447s12.95618,6.36138,12.82128,13.8942Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#31319d"
        />
        <path
          id="e94ecbaf-2ca7-4fd5-871d-ab097a8f2c0d-527"
          data-name="Path 2431"
          d="M597.36476,469.01468l-3.76388-5.01867.89129-.66895,3.06651,4.0886,12.0726-9.87642.7058.86262Z"
          transform="translate(-230.89001 -213.15682)"
          fill="#fff"
        />
      </svg>
      <button
        @click="start()"
        class="inline-flex cursor-pointer items-center rounded-md border border-transparent bg-midnight-700 px-4 py-2 text-xs font-semibold tracking-wider text-white uppercase transition hover:bg-wt-blue-d focus:border-midnight-900 focus:ring-3 focus:ring-wt-blue-l focus:outline-hidden active:bg-midnight-500 disabled:cursor-not-allowed disabled:opacity-50"
        :disabled="data.serviceStatus.value === 'unreachable'"
      >
        {{ $t('compatibilityTest.startBtn') }}
      </button>
      <div
        v-if="data.serviceStatus.value === 'reachable'"
        class="mt-2 text-center text-sm font-semibold text-wt-green-d"
      >
        <i class="fa-solid fa-check"></i>
        {{ $t('compatibilityTest.serviceStatus.reachable') }}
      </div>
      <div
        v-if="data.serviceStatus.value === 'unreachable'"
        class="mt-2 text-center text-sm font-semibold text-wt-red-dr"
      >
        <i class="fa-solid fa-xmark"></i>
        {{ $t('compatibilityTest.serviceStatus.unreachable') }}
      </div>
    </div>
    <div v-if="isStarted && !isFinished">
      <i class="fa-solid fa-circle-notch fa-spin"></i>
      <p class="text-base font-semibold">
        {{ $t('compatibilityTest.loading') }}
      </p>
    </div>
    <div
      v-if="
        !isStarted && isFinished && isGuest && !email && !streamerUnreachable
      "
    >
      <div
        class="mx-auto mt-16 max-w-xl bg-white text-center shadow-xs sm:rounded-lg"
      >
        <div class="px-4 py-5 sm:p-6">
          <h3 class="text-lg leading-6 font-medium text-wt-gray-dr">
            {{ $t('compatibilityTest.result.title') }}
          </h3>
          <div class="mx-auto mt-2 max-w-xl text-sm text-wt-gray-d">
            <p>
              {{ $t('compatibilityTest.result.description') }}
            </p>
          </div>
          <form class="mt-5 justify-center sm:flex sm:items-center">
            <div class="w-full sm:max-w-xs">
              <Input
                v-model="emailInput"
                id="email"
                name="email"
                type="email"
                :label="$t('compatibilityTest.result.email')"
                :placeholder="$t('compatibilityTest.result.myMail')"
              />
            </div>
            <button
              @click="sendResults()"
              class="mt-3 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-wt-blue-d px-4 py-2 font-medium text-white shadow-xs hover:bg-midnight-700 focus:ring-2 focus:ring-midnight-500 focus:ring-offset-2 focus:outline-hidden sm:ms-3 sm:mt-0 sm:w-auto sm:text-sm"
            >
              {{ $t('common.action.send') }}
            </button>
          </form>
        </div>
      </div>
    </div>

    <div v-if="!isStarted && isFinished && streamerUnreachable">
      <div
        class="mx-auto mt-16 mb-4 flex size-12 items-center justify-center rounded-full bg-red-600"
      >
        <i class="fa-solid fa-circle-xmark"></i>
      </div>
      <div class="text-center">
        <h3
          id="modal-title"
          class="text-lg leading-6 font-semibold text-wt-gray-dr"
        >
          Server error
        </h3>
        <div class="mt-2">
          <p class="text-sm text-wt-gray-d">
            A server error occurred, please retry.
          </p>
          <p>
            <button @click="reload()" class="text-wt-gray-d underline">
              Retry
            </button>
          </p>
        </div>
      </div>
    </div>

    <div
      v-show="
        !isStarted && isFinished && (!isGuest || email) && !streamerUnreachable
      "
    >
      <div
        class="mx-auto mt-16 mb-4 flex size-12 items-center justify-center rounded-full bg-green-600"
      >
        <i class="fa-solid fa-check"></i>
      </div>
      <div class="text-center">
        <h3
          id="modal-title"
          class="text-lg leading-6 font-semibold text-wt-gray-dr"
        >
          {{ $t('compatibilityTest.sent.title') }}
        </h3>
        <div class="mt-2">
          <p class="text-sm text-wt-gray-d">
            {{ $t('compatibilityTest.sent.description') }}
          </p>
        </div>

        <hr class="my-16" />

        <div class="mx-auto mt-4 w-full md:w-full">
          <div class="overflow-hidden bg-white shadow-xs sm:rounded-md">
            <ul>
              <li class="border-b border-wt-gray-lr">
                <div class="px-4 py-4 sm:px-6">
                  <div class="flex items-center justify-between">
                    <p
                      class="truncate text-sm leading-5 font-medium text-black"
                    >
                      {{ $t('compatibilityTest.os') }}
                    </p>
                    <div class="ms-2 flex shrink-0">
                      <p
                        class="inline-flex rounded-full px-2 text-xs leading-5 font-semibold"
                        :class="{
                          'bg-green-100 text-green-800': results.os.value,
                          'bg-red-100 text-red-800': !results.os.value,
                        }"
                      >
                        {{
                          results.os.value
                            ? $t('compatibilityTest.success')
                            : $t('compatibilityTest.failure')
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </li>

              <li class="border-b border-wt-gray-lr">
                <div class="px-4 py-4 sm:px-6">
                  <div class="flex items-center justify-between">
                    <p
                      class="truncate text-sm leading-5 font-medium text-black"
                    >
                      {{ $t('compatibilityTest.browser') }}
                    </p>
                    <div class="ms-2 flex shrink-0">
                      <p
                        class="inline-flex rounded-full px-2 text-xs leading-5 font-semibold"
                        :class="{
                          'bg-green-100 text-green-800':
                            results.browser.value
                            && results.browserVersion.value,
                          'text-gray-800': results.browser.value === null,
                          'bg-red-100 text-red-800': !(
                            results.browser.value
                            && results.browserVersion.value
                          ),
                        }"
                      >
                        {{
                          results.browser.value && results.browserVersion.value
                            ? $t('compatibilityTest.success')
                            : results.browser.value === null
                              ? $t('compatibilityTest.skipped')
                              : $t('compatibilityTest.failure')
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </li>

              <li class="border-b border-wt-gray-lr">
                <div class="px-4 py-4 sm:px-6">
                  <div class="flex items-center justify-between">
                    <p
                      class="truncate text-sm leading-5 font-medium text-black"
                    >
                      {{ $t('compatibilityTest.streaming') }}
                    </p>
                    <div class="ms-2 flex shrink-0">
                      <p
                        class="inline-flex rounded-full px-2 text-xs leading-5 font-semibold"
                        :class="{
                          'bg-green-100 text-green-800':
                            results.webRtcCompatible.value === true,
                          'text-gray-800':
                            results.webRtcCompatible.value == null,
                          'bg-red-100 text-red-800':
                            results.webRtcCompatible.value === false,
                        }"
                      >
                        {{
                          results.webRtcCompatible.value
                            ? $t('compatibilityTest.success')
                            : results.webRtcCompatible.value === null
                              ? $t('compatibilityTest.skipped')
                              : $t('compatibilityTest.failure')
                        }}
                        <span
                          v-if="
                            results.webRtcCompatible.value && data.candidateType
                          "
                          class="ms-1"
                          >({{
                            data.candidateType.value === 'relay'
                              ? $t('compatibilityTest.turn')
                              : $t('compatibilityTest.direct')
                          }})</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </li>

              <li class="border-b border-wt-gray-lr">
                <div class="px-4 py-4 sm:px-6">
                  <div class="flex items-center justify-between">
                    <p
                      class="truncate text-sm leading-5 font-medium text-black"
                    >
                      {{ $t('compatibilityTest.quality') }}
                    </p>
                    <div class="ms-2 flex shrink-0">
                      <p
                        class="inline-flex rounded-full px-2 text-xs leading-5 font-semibold"
                        :class="{
                          'bg-green-100 text-green-800':
                            totalKbps > 0
                            && totalKbps / totalKbpsCount > 106
                            && 1
                              - stats.packetsLost
                                / (stats.packetsLost + stats.packetsReceived)
                              >= 0.6,
                          'text-gray-800': totalKbps === 0,
                          'bg-red-100 text-red-800':
                            totalKbps > 0
                            && !(
                              totalKbps / totalKbpsCount > 106
                              && 1
                                - stats.packetsLost
                                  / (stats.packetsLost + stats.packetsReceived)
                                >= 0.6
                            ),
                        }"
                      >
                        {{
                          totalKbps > 0
                          && totalKbps / totalKbpsCount > 106
                          && 1
                            - stats.packetsLost
                              / (stats.packetsLost + stats.packetsReceived)
                            >= 0.6
                            ? $t('compatibilityTest.success')
                            : totalKbps === 0
                              ? $t('compatibilityTest.skipped')
                              : $t('compatibilityTest.failure')
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div v-show="results.webRtcCompatible.value">
              <p class="mt-5 font-bold">Qualité de votre connexion:</p>
              <div
                class="mx-auto my-6 block h-[150px] w-[150px]"
                ref="gauge"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isStarted && !isFinished" class="mt-5 flex justify-center">
      <div class="w-4/5">
        <div class="relative pt-1">
          <div
            class="mb-4 flex h-6 overflow-hidden rounded-xs bg-wt-blue-lr text-xs"
          >
            <div
              class="relative flex flex-col justify-center bg-wt-blue-d text-center whitespace-nowrap text-white shadow-none transition-all"
              :style="{
                width: (currentTime / time) * 100 + '%',
              }"
            >
              <ul class="clouds">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <video
      v-if="isStarted && !isFinished"
      @canplay="videoReady"
      class="mx-auto mt-12 w-4/5 rounded-md"
      autoplay
      ref="videoEl"
      muted
      playinfullscreen="true"
      playsinline
    ></video>
  </div>
</template>

<style>
  .clouds {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .clouds li {
    position: absolute;
    display: block;
    list-style: none;
    opacity: 0.1;
    width: 20px;
    height: 12px;
    background-image: url(data:image/png;base64,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);
    animation: animate 25s linear infinite;
    bottom: 4px;
  }

  .clouds li:nth-child(1) {
    opacity: 0.2;
    animation-duration: 7s;
  }

  .clouds li:nth-child(2) {
    bottom: 6px;
    animation-duration: 12s;
  }

  .clouds li:nth-child(3) {
    animation-duration: 20s;
  }

  .clouds li:nth-child(4) {
    opacity: 0.2;
    bottom: 6px;
    animation-duration: 12s;
  }

  @keyframes animate {
    0% {
      left: -10%;
    }

    100% {
      left: 140%;
    }
  }

  .gauge-container > .gauge .dial {
    stroke: #eee;
    stroke-width: 2;
    fill: rgba(0, 0, 0, 0);
  }
  .gauge-container > .gauge .value {
    stroke: rgb(47, 227, 255);
    stroke-width: 10;
    fill: rgba(0, 0, 0, 0);
  }
  .gauge-container > .gauge .value-text {
    font-family: sans-serif;
    font-weight: bold;
    font-size: 1em;
  }
</style>

<script setup lang="ts">
  import Gauge, { type GaugeInstance } from 'svg-gauge'
  import { onMounted, ref, watch } from 'vue'
  import { useBrowser } from '../../utils/browser'
  import {
    CONNECTION_CLOSED,
    CONNECTION_READY,
    KBPS_UPDATED,
    MEDIA_STREAM_CANDIDATE_ADD,
    MEDIA_STREAM_CANDIDATE_FLUSH,
    MEDIA_STREAM_INITIALIZED,
    MEDIA_STREAM_SDP_AVAILABLE,
    STREAM_ERROR,
    UNSTABLE_CONNECTION,
    mEvent,
  } from '../../utils/events'
  import { i18n } from '../../utils/i18n'
  import rtcp from '../../utils/rtcp'
  import socket from '../../utils/socket'
  import Input from '../ui/form/Input.vue'

  const connected = ref(false)
  const retryRtc = ref(0)
  const isFinished = ref(false)
  const isStarted = ref(false)
  const kbps = ref<number | null>(null)
  const unstableConnectionCount = ref(0)
  const browser = useBrowser()

  const totalKbps = ref(0)
  const totalKbpsCount = ref(0)

  const emailInput = ref<string>('')
  const email = ref<string | null>(null)

  const debugMode = ref(false)
  const time = ref(20)

  const gauge = ref<HTMLElement | null>(null)
  const gaugeInstance = ref<GaugeInstance | null>(null)
  const stats = ref<{
    packetsLost: number
    packetsReceived: number
  }>({
    packetsLost: 0,
    packetsReceived: 0,
  })
  const endTimeout = ref<number | null>(null)
  const stopwatch = ref<number | null>(null)
  const currentTime = ref(0)

  const stunServers = ref<RTCConfiguration | null>(null)

  const videoEl = ref<HTMLVideoElement | null>(null)

  const data = {
    os: ref<string | null>(null),
    osDetails: ref<string | null>(null),
    browser: ref<string | null>(null),
    browserVersion: ref<string | null>(null),
    localCandidate: ref<string | null>(null),
    remoteCandidate: ref<string | null>(null),
    candidateType: ref<'relay' | 'host' | null>(null),
    serviceStatus: ref<'reachable' | 'unreachable' | null>(null),
  }

  const results = {
    os: ref<boolean | null>(null),
    browser: ref<boolean | null>(null),
    browserVersion: ref<boolean | null>(null),
    webRtcCompatible: ref<boolean | null>(null),
  }

  const streamerUnreachable = ref(false)

  const props = defineProps({
    streamUrl: String,
    isGuest: Boolean,
  })

  const videoReady = () => {
    if (stopwatch.value == null) {
      stopwatch.value = window.setInterval(() => {
        currentTime.value += 0.06
        const newStats = rtcp.allStats()
        if (
          newStats
          && typeof newStats === 'object'
          && 'packetsLost' in newStats
          && 'packetsReceived' in newStats
        ) {
          stats.value = newStats as {
            packetsLost: number
            packetsReceived: number
          }
        }
      }, 50)
    }
  }

  const reload = () => {
    window.location.reload()
  }

  const onMediaStreamInitialized = (data: { stunturn: RTCConfiguration }) => {
    console.debug('Connecting to RTC...')

    socket.send({
      id: 'initwebrtc',
      data: JSON.stringify({
        os_platform: 'LINUX',
        is_mobile: false,
      }),
    })

    rtcp.isTest(true)
    rtcp.start(data.stunturn, 'LINUX', false)

    stunServers.value = data.stunturn
  }

  const onMediaStreamSdpAvailable = (data: {
    sdp: RTCSessionDescriptionInit
  }) => {
    console.debug('Loading media...')
    rtcp.setRemoteDescription(data.sdp, videoEl.value, null)
  }
  const onMediaStreamCandidateAdd = (data: {
    candidate: RTCIceCandidateInit
  }) => {
    rtcp.addCandidate(data.candidate)
  }
  const onMediaStreamCandidateFlush = () => {
    rtcp.flushCandidate()
  }

  const onConnectionClosed = () => {
    connected.value = false

    if (!isFinished.value) {
      retryRtc.value++
      console.debug('Connection closed, retrying...')

      if (endTimeout.value) {
        if (endTimeout.value) {
          window.clearTimeout(endTimeout.value)
        }
        endTimeout.value = null
        if (stopwatch.value) {
          window.clearInterval(stopwatch.value)
        }
        stopwatch.value = null
        currentTime.value = 0
      }

      if (retryRtc.value < 8) {
        socket.close()
        rtcp.stop()
        setTimeout(() => {
          initWebRTC()
        }, 1000)
      } else {
        results.webRtcCompatible.value = false
        isFinished.value = true
        socket.close()
        rtcp.stop()
      }
    }
  }

  const onConnectionReady = (infos: {
    local?: { candidate: string }
    remote?: { candidate: string }
  }) => {
    data.localCandidate.value = infos.local?.candidate ?? ''
    data.remoteCandidate.value = infos.remote?.candidate ?? ''
    data.candidateType.value =
      (infos.remote?.candidate?.indexOf('relay') ?? -1) > -1 ? 'relay' : 'host'
    connected.value = true
  }

  const start = () => {
    isStarted.value = true
    checkOS()
    checkBrowser()
    startRtc()
  }

  const startRtc = () => {
    if (results.browser.value === true) {
      console.debug('Starting RTC...')
      initWebRTC()
    } else {
      isFinished.value = true
    }
  }

  const initWebRTC = () => {
    socket.init(props.streamUrl, '')

    endTimeout.value = window.setTimeout(() => {
      isFinished.value = true
      results.webRtcCompatible.value = true
      if (stopwatch.value) {
        window.clearInterval(stopwatch.value)
      }
      stopwatch.value = null
      currentTime.value = 0
      socket.close()
      rtcp.stop()

      if (gaugeInstance.value) {
        gaugeInstance.value.setValueAnimated(
          100
            - (stats.value.packetsLost
              / (stats.value.packetsLost + stats.value.packetsReceived))
              * 100,
          3
        )
      }
    }, time.value * 1000)
  }

  const checkOS = () => {
    data.os.value = browser.osName() || null
    data.osDetails.value = browser.osDetails() || null

    results.os.value =
      data.os.value === 'MACOS'
      || data.os.value === 'IPAD'
      || data.os.value === 'IPHONE'
      || data.os.value === 'UNIX'
      || data.os.value === 'ANDROID'
      || data.os.value === 'LINUX'
      || data.os.value === 'WIN_10'
  }

  const checkBrowser = () => {
    const browserInfos = browser.browserInfos()
    data.browser.value = browserInfos[0] || null
    data.browserVersion.value = browserInfos[1] || null

    results.browser.value =
      data.browser.value === 'CHROME'
      || data.browser.value === 'FIREFOX'
      || (data.browser.value === 'SAFARI' && browser.isMobile())

    if (!data.browserVersion.value) {
      results.browserVersion.value = false
      return
    }

    const browserVersionMatch =
      data.browserVersion.value.match(/^([0-9]*)\.*/)?.[1]
    const browserVersionNumber = browserVersionMatch
      ? parseInt(browserVersionMatch)
      : 0

    if (browserVersionNumber === 0) {
      results.browserVersion.value = false
      return
    }

    switch (data.browser.value) {
      case 'CHROME':
        results.browserVersion.value = browserVersionNumber >= 101
        break
      case 'EDGE':
        results.browserVersion.value = browserVersionNumber >= 104
        break
      case 'SAFARI':
        results.browserVersion.value = browserVersionNumber >= 604
        break
      case 'FIREFOX':
        results.browserVersion.value = browserVersionNumber >= 121
        break
      case 'OPERA':
        results.browserVersion.value = browserVersionNumber >= 90
        break
      default:
        results.browserVersion.value = false
    }
  }

  const onKbpsUpdated = (data: number) => {
    if (isFinished.value) {
      return
    }

    kbps.value = data
    totalKbps.value += data
    totalKbpsCount.value++
  }

  const onUnstableConnection = () => {
    if (isFinished.value) {
      return
    }

    unstableConnectionCount.value++
  }

  const sendResults = () => {
    email.value = props.isGuest ? emailInput.value : null

    fetch(`/api/compatibility-checks`, {
      method: 'POST',
      body: JSON.stringify({
        email: email.value,
        operating_system: data.osDetails.value,
        operating_system_is_ok: browser.isOSCompatible(),
        browser: data.browser.value,
        browser_version: data.browserVersion.value,
        browser_is_ok: browser.isBrowserCompatible(),
        h264_support: results.webRtcCompatible.value,
        network_stability: results.webRtcCompatible.value
          ? 1
            - stats.value.packetsLost
              / (stats.value.packetsLost + stats.value.packetsReceived)
          : null,
        network_speed: results.webRtcCompatible.value
          ? (totalKbps.value / totalKbpsCount.value).toFixed(2)
          : null,
        webrtc_debug: JSON.stringify({
          local_candidate: data.localCandidate.value,
          remote_candidate: data.remoteCandidate.value,
        }),
      }),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-TOKEN':
          document
            .querySelector('meta[name="csrf-token"]')
            ?.getAttribute('content') || '',
      },
    })
  }

  const onStreamError = (data: { id?: number }) => {
    if (data.id && (data.id === 102 || data.id === 101)) {
      results.webRtcCompatible.value = false

      if (endTimeout.value) {
        if (endTimeout.value) {
          window.clearTimeout(endTimeout.value)
        }
        endTimeout.value = null
        if (stopwatch.value) {
          window.clearInterval(stopwatch.value)
        }
        stopwatch.value = null
        currentTime.value = 0
      }

      isFinished.value = true
    } else if (data.id && data.id === 301) {
      results.webRtcCompatible.value = null
      streamerUnreachable.value = true

      if (endTimeout.value) {
        if (endTimeout.value) {
          window.clearTimeout(endTimeout.value)
        }
        endTimeout.value = null
        if (stopwatch.value) {
          window.clearInterval(stopwatch.value)
        }
        stopwatch.value = null
        currentTime.value = 0
      }

      isFinished.value = true
    }
  }

  const checkServiceAvailability = () => {
    fetch('https://' + props.streamUrl)
      .then((response) => {
        if (response.status === 400) {
          console.debug('Service is reachable.')
          data.serviceStatus.value = 'reachable'
        } else {
          console.error('Service is unreachable.')
          data.serviceStatus.value = 'unreachable'
        }
      })
      .catch((error) => {
        console.error('Fetch error:', error)
        data.serviceStatus.value = 'unreachable'
      })
  }

  onMounted(() => {
    checkServiceAvailability()
    mEvent.subscribe(MEDIA_STREAM_INITIALIZED, onMediaStreamInitialized)
    mEvent.subscribe(MEDIA_STREAM_SDP_AVAILABLE, onMediaStreamSdpAvailable)
    mEvent.subscribe(MEDIA_STREAM_CANDIDATE_ADD, onMediaStreamCandidateAdd)
    mEvent.subscribe(MEDIA_STREAM_CANDIDATE_FLUSH, onMediaStreamCandidateFlush)
    mEvent.subscribe(CONNECTION_CLOSED, onConnectionClosed)
    mEvent.subscribe(CONNECTION_READY, onConnectionReady)
    mEvent.subscribe(KBPS_UPDATED, onKbpsUpdated)
    mEvent.subscribe(UNSTABLE_CONNECTION, onUnstableConnection)
    mEvent.subscribe(STREAM_ERROR, onStreamError)

    if (gauge.value) {
      gaugeInstance.value = Gauge(gauge.value, {
        max: 100,
        // custom label renderer
        label: function (value) {
          if (value < 60) {
            return i18n.t('compatibilityTest.quality_labels[0]') // green
          } else if (value < 80) {
            return i18n.t('compatibilityTest.quality_labels[1]') // orange
          } else if (value <= 100) {
            return i18n.t('compatibilityTest.quality_labels[2]') // red
          } else {
            return '-'
          }
        },
        // Custom dial colors (Optional)
        color: function (value) {
          if (value < 60) {
            return '#C53B36' // Red
          } else if (value < 80) {
            return '#facc15' // Yellow
          } else if (value <= 100) {
            return '#16a34a' // Green
          } else {
            return '#9ca3af' // Gray
          }
        },
      })
    }
  })

  watch(isFinished, (val: boolean) => {
    if (val) {
      isStarted.value = false

      if (!props.isGuest) {
        sendResults()
      }
    }
  })
</script>
